import { render, staticRenderFns } from "./OwnerMissingInfoGroupBusinesses.vue?vue&type=template&id=7a852d54&"
import script from "./OwnerMissingInfoGroupBusinesses.vue?vue&type=script&lang=js&"
export * from "./OwnerMissingInfoGroupBusinesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
